import { Dialog } from '@ordr-as/umami-react/dialog';
import { TextInput } from '@ordr-as/umami-react/form';
import useIntl from '../../../../hooks/useIntl';
import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useCartStore } from '../../../../context/cart/CartStore';

interface CheckoutCommentDialogProps {
  setOpenCommentDialog: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
}

const CheckoutCommentDialog = (props: CheckoutCommentDialogProps) => {
  const { setOpenCommentDialog, isOpen } = props;
  const { comment, saveComment } = useCartStore((state) => ({
    comment: state.cart.comment,
    saveComment: state.saveComment,
  }));

  const intl = useIntl();

  const [commentState, setCommentState] = useState<string>();

  const saveData = useCallback(() => {
    saveComment(commentState);
    setCommentState(undefined);
    setOpenCommentDialog(false);
  }, [commentState, saveComment, setOpenCommentDialog]);

  useEffect(() => {
    if (isOpen) {
      setCommentState(comment);
    }
  }, [isOpen, comment]);

  const handleOnDataChange = useCallback((value: string) => {
    setCommentState(value);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      onClose={() => setOpenCommentDialog(false)}
      title={intl.formatMessage({ id: `checkout.note.header` })}
      onAction={saveData}
      actionLabel={intl.formatMessage({ id: 'generic.save' })}
      alignTop
    >
      <TextInput
        autoFocus
        onChange={handleOnDataChange}
        value={commentState}
        multiline
        label={intl.formatMessage({ id: `checkout.note.description` })}
        fullWidth
      />
    </Dialog>
  );
};

export default CheckoutCommentDialog;
